import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Optional, Silent } from "@/__main__/data-model.mjs";

export const model = {
  matches: [
    {
      id: String,
      playerMatch: Silent({
        id: String,
        playerMatchStats: {
          lp: Optional(Number),
          deltaLp: Optional(Number),
          kills: Number,
          deaths: Number,
          assists: Number,
        },
      }),
    },
  ],
} satisfies ModelDefinition;

const LolMatchListModel = createModel({
  data: {
    matchlist: model,
  },
}).transform(model.matches, (data) => data.data.matchlist.matches);

export type LolMatchList = FromModel<typeof LolMatchListModel>;

export default LolMatchListModel;
